import Y2018Q3 from './2018Q3.geojson?url';
import Y2018Q4 from './2018Q4.geojson?url';
import Y2019Q1 from './2019Q1.geojson?url';
import Y2019Q2 from './2019Q2.geojson?url';
import Y2019Q3 from './2019Q3.geojson?url';
import Y2019Q4 from './2019Q4.geojson?url';
import Y2020Q1 from './2020Q1.geojson?url';
import Y2020Q2 from './2020Q2.geojson?url';
import Y2020Q3 from './2020Q3.geojson?url';
import Y2020Q4 from './2020Q4.geojson?url';
import Y2021Q1 from './2021Q1.geojson?url';
import Y2021Q2 from './2021Q2.geojson?url';
import Y2021Q3 from './2021Q3.geojson?url';
import Y2021Q4 from './2021Q4.geojson?url';
import Y2022Q1 from './2022Q1.geojson?url';
import Y2022Q2 from './2022Q2.geojson?url';
import Y2022Q3 from './2022Q3.geojson?url';
import Y2022Q4 from './2022Q4.geojson?url';
import Y2023Q1 from './2023Q1.geojson?url';
import Y2023Q2 from './2023Q2.geojson?url';
import Y2023Q3 from './2023Q3.geojson?url';
import Y2023Q4 from './2023Q4.geojson?url';
import Y2024Q1 from './2024Q1.geojson?url';
import Y2024Q2 from './2024Q2.geojson?url';
import Y2024Q3 from './2024Q3.geojson?url';
import Y2025Q1 from './2025Q1.geojson?url';
import Y2025Q2 from './2025Q2.geojson?url';
import Y2026Q1 from './2026Q1.geojson?url';

export default {
    '2018Q3': Y2018Q3,
    '2018Q4': Y2018Q4,
    '2019Q1': Y2019Q1,
    '2019Q2': Y2019Q2,
    '2019Q3': Y2019Q3,
    '2019Q4': Y2019Q4,
    '2020Q1': Y2020Q1,
    '2020Q2': Y2020Q2,
    '2020Q3': Y2020Q3,
    '2020Q4': Y2020Q4,
    '2021Q1': Y2021Q1,
    '2021Q2': Y2021Q2,
    '2021Q3': Y2021Q3,
    '2021Q4': Y2021Q4,
    '2022Q1': Y2022Q1,
    '2022Q2': Y2022Q2,
    '2022Q3': Y2022Q3,
    '2022Q4': Y2022Q4,
    '2023Q1': Y2023Q1,
    '2023Q2': Y2023Q2,
    '2023Q3': Y2023Q3,
    '2023Q4': Y2023Q4,
    '2024Q1': Y2024Q1,
    '2024Q2': Y2024Q2,
    '2024Q3': Y2024Q3,
    '2025Q1': Y2025Q1,
    '2025Q2': Y2025Q2,
    '2026Q1': Y2026Q1,
};
